import React from 'react';
import { createStyles, makeStyles, Theme, Typography, Card, MenuItem, FormControl, Select, TextField} from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
// import { GridContainer } from "components/GridContainer";
import { GridItem } from "components/GridItem";
//import { TimePicker } from '@mui/x-date-pickers/TimePicker';
// import { TimePicker } from '@material-ui/pickers';
// import dayjs, { Dayjs } from 'dayjs';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minWidth: 275,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        div_row: {
            display: 'flex',
            flexDirection: 'row',
        },
        div_col:{
            display: 'flex',
            flexDirection: 'column',
        },
        pm: {
            marginLeft: theme.spacing(1),
        },
    }),
);

interface IProps  {
    onChargeUpdate: (newCharge: string) => void;
}

export const LateCheckOutCard: React.FC<IProps> = ({ onChargeUpdate})  => {
  const classes = useStyles();
  const [time, setTime] = React.useState('');
  const [charge, setCharge] = React.useState('');

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setTime(event.target.value as string);
    const newCharge = calculateCharge(event.target.value as string);
    setCharge(newCharge);
    onChargeUpdate(newCharge);
  };

  const calculateCharge = (selectedTime: string): string => {
      let baseCharge = 35;
      let additionalCharge = (parseInt(selectedTime, 10) - 1) * 10;
      let totalCharge = baseCharge + additionalCharge;
      return `SGD ${totalCharge.toFixed(2)}`;
  };

  const timeOptions = Array.from({ length: 3 }, (_, index) => index + 1);

  return (
    <Card className={classes.root} variant="outlined">       
        <CardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <GridItem className={classes.div_row}>                 
                <GridItem  xs={12} sm={8} className={classes.div_col}>
                    <GridItem  xs={12} sm={12}>
                        <Typography variant='h6'>
                            Checkout Time Extended
                        </Typography>
                    </GridItem>
                    <GridItem xs={12} sm={12} className={classes.div_row}>
                        <GridItem xs={12} sm={3}>
                            <FormControl>
                                <Select
                                    value={time}
                                    onChange={handleChange}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'time input' }}
                                    >
                                    {timeOptions.map((value) => (
                                        <MenuItem key={value} value={value}>
                                        {value.toString().padStart(2, '0')}
                                        </MenuItem>
                                    ))}
                                </Select>
                                
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={9}>
                            <Typography className={classes.pm} style={{margin: 5}}>
                                HOUR
                            </Typography>
                        </GridItem>
                        
                    </GridItem>
                </GridItem>

                <GridItem  xs={12} sm={6} className={classes.div_col}>
                    <GridItem  xs={12} sm={12}>
                        <Typography variant='h6'>
                            Charges
                        </Typography>
                    </GridItem>               
                    <GridItem xs={12} sm={12}>
                        <form noValidate autoComplete="off">
                            <TextField id="outlined-basic" value={charge} variant="outlined" InputProps={{ readOnly: true }}  />
                        </form>
                    </GridItem>                   
                </GridItem>
            </GridItem>
        </CardContent>
    </Card>
  );
};
